import { FC } from 'react'
import { Spinner } from 'ui'

import { t } from 'translations'
import { Badge } from 'ui'

type Props = {
  text: string
  className?: string
}

const TranslatedSpinner: FC<Props> = ({ text = 'LOADING', className }) => {
  return className ? (
    <span className={className}>
      <Spinner size="sm" /> {t(text)}
    </span>
  ) : (
    <Badge variant="secondary" className="ml-2">
      <Spinner size="sm" /> {t(text)}
    </Badge>
  )
}

export default TranslatedSpinner
